export var ProgressBarItemState;
(function (ProgressBarItemState) {
    /**
     * The step is already done
     */
    ProgressBarItemState["PREVIOUS"] = "prev";
    /**
     * It's the current step
     */
    ProgressBarItemState["CURRENT"] = "current";
    /**
     * Next step
     */
    ProgressBarItemState["NEXT"] = "next";
    /**
     * current finished state
     */
    ProgressBarItemState["CURRENT_FINISHED"] = "current-finished";
})(ProgressBarItemState || (ProgressBarItemState = {}));
